import axios from 'axios';
import { HTTP_STATUS, HTTP_STATUS_MESSAGE } from '@/constant';
import toastr from 'toastr';

const BASE_URL = `${process.env.SHIFT_V2_API_BASE_URL}`;

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

// レスポンスがエラーの時に発火
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    let message = HTTP_STATUS_MESSAGE.DEFAULT;

    // { errorHandle: false }を設定することで、エラー処理を無視する
    if (error.config.data && JSON.parse(error.config.data).errorHandle === false) {
      return error.response;
    }

    const { status } = error.response;

    switch (status) {
      case HTTP_STATUS.FORBIDDEN:
        message = HTTP_STATUS_MESSAGE.FORBIDDEN;
        break;

      case HTTP_STATUS.NOT_FOUND:
        message = HTTP_STATUS_MESSAGE.NOT_FOUND;
        break;

      case HTTP_STATUS.LEGAL_REASONS:
        message = HTTP_STATUS_MESSAGE.LEGAL_REASONS;
        break;

      default:
        break;
    }

    toastr.options.closeButton = true;
    toastr.options.timeOut = 5000;
    toastr.options.toastClass = 'alert-danger2';

    toastr.error(message);

    //   notify({
    //     duration: 6000,
    //     position: 'right',
    //     message,
    //     classes: 'alert-danger2',
    //   });
    return Promise.reject(error);
  }
);

export default instance;
